import React from "react";
import styles from "./drawer-icon-container.module.scss";
import { useI18N } from "@src/language/language-context";

interface DrawerIconContainerProps {
  icon: string;
  status?: string;
}

const cssClassName = "drawer-icon-container";

export const DrawerIconContainer = ({
  icon,
  status = "default",
}: DrawerIconContainerProps) => {
  const i18n = useI18N();

  const texts = {
    altText: i18n("modules.drawerIconContainer.altText"),
  };

  return (
    <div
      className={`${styles[cssClassName]} ${
        styles[`${cssClassName}--${status}`]
      }`}
    >
      <img src={icon} alt={texts.altText} />
    </div>
  );
};
